/* @flow */

import type { Storage } from "crustate";
import type { Client } from "@awardit/graphql-ast-client";
import type { BrandRequest, BrandResponse } from "@crossroads/shop-state/brand";

import { BRAND_REQUEST, BRAND_RESPONSE } from "@crossroads/shop-state/brand";
import { brand } from "queries";
import { PAGE_SIZE, loadCampaignAwareProductList } from "./product-list-pagination";

const getBrandPath = (filters: any): string => {
  const brandFilter = filters.find(x => x.code === "manufacturer");

  return brandFilter && brandFilter.value ?
    `/brand/${encodeURIComponent(brandFilter.value)}` :
    "/brand";
};

const registerClient = (storage: Storage, client: Client<{}>) => {
  storage.addEffect({
    effect: async (msg: BrandRequest) => {
      const variables = {
        filter: msg.filters,
        sort: msg.sort,
        pageSize: PAGE_SIZE,
        page: msg.page == null ? 1 : msg.page,
      };
      const { products } = await loadCampaignAwareProductList({
        client,
        query: brand,
        variables,
        productsPerRow: (msg: any).productsPerRow,
        productListPath: "products",
        pathname: getBrandPath(msg.filters),
      });

      return ({
        tag: BRAND_RESPONSE,
        data: products,
      }: BrandResponse);
    },
    subscribe: { [BRAND_REQUEST]: true },
  });
};

export default registerClient;
